export default {
  leading: 6 as const,
  row: 12 as const,
  section: 24 as const,
  chapter: 42 as const,
};